import { descend, map, prop, sort } from 'ramda'

import { Params, StatementList, StatementStatus, isStatementStatus } from 'app/dataTypes/cafeteria/compensation/statements'
import SimpleDate from 'app/common/classes/simple-date'
import toFixedValue from 'app/common/lib/toFixedValue'

import type { Request } from '../../../index'


const apiDateFormat = 'YYYY-MM-DD' as const

type ParamsApi = {
  student_id: number
  food_supplier_id: number
  date_from: string
  date_to: string
}

export const convertParams = ({
  studentID,
  supplierID,
  dateFrom,
  dateTo,
}: Params): [ParamsApi, null] => {
  return [{
    student_id: parseInt(studentID, 10),
    food_supplier_id: parseInt(supplierID, 10),
    date_from: dateFrom.getString(apiDateFormat),
    date_to: dateTo.getString(apiDateFormat),
  }, null]
}

type StatementsApi = Array<{
  id: number
  status: number
  datetime: string
  value: number
}>

export const convertResult = (data: StatementsApi): StatementList => {
  const sorted = sort(descend(prop('datetime')), data)
  return map(({ id, status, datetime, value }) => ({
    ID: String(id),
    status: isStatementStatus(status) ? status : StatementStatus.Unknown,
    date: new SimpleDate(datetime),
    value: toFixedValue(value),
  }), sorted)
}

export const GET_COMPENSATION_WITHDRAW_ORDERS: Request<Params, StatementList, void> = [
  'cabinet/compensation/withdraw_orders',
  'get',
  ['data', 'withdraw_orders'],
]
